export function fileUrl(id: string, width: number, height: number, imageAsType: number): string {
    if (!id) return '';

    return `${import.meta.env.VITE_FILE_API_BASE}/getfile?idFile=${id}&size=${width}x${height}&imageAsType=${imageAsType}`;
}
